import { inject } from '@angular/core';
import { CanMatchFn, ResolveFn, Router, UrlSegment } from '@angular/router';
import {
  FeatureFlagsService,
  FEATURE_FLAGS,
  AUTH_MAIN_ROUTE,
  AUTH_ROUTES,
} from '@kuiper/ibusiness-core';

const SUPPORTED_LANGS = ['en', 'ar'] as const;
type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export const languageCanMatch: CanMatchFn = (
  _route,
  segments: UrlSegment[]
) => {
  const lang = segments[0]?.path;
  return (SUPPORTED_LANGS as readonly string[]).includes(lang);
};

export const languageResolver: ResolveFn<boolean> = route => {
  const featureFlagService = inject(FeatureFlagsService);
  const router = inject(Router);

  const isLandingPageEnabled = featureFlagService.getFeatureFlagValue(
    FEATURE_FLAGS.SYSTEM.landing_page
  );

  if (!isLandingPageEnabled) {
    router.navigate(['/', AUTH_MAIN_ROUTE, AUTH_ROUTES.LOGIN]);
    return false;
  }

  return true;
};
